import React, { useState, useEffect } from "react";
import db from "firebase/dbConfig";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TableSortLabel from "@material-ui/core/TableSortLabel";

export default function Admin() {
  const [users, setUsers] = useState([]);
  const [statusCounts, setStatusCounts] = useState({
    active: 0,
    cortesy: 0,
    canceled: 0,
    past_due: 0,
  });
  const [groupedUsers, setGroupedUsers] = useState({
    active: [],
    cortesy: [],
    canceled: [],
    past_due: [],
  });
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("recordsCount");

  useEffect(() => {
    const fetchUsersWithStatus = async () => {
      const snapshot = await db.collection("users").get();

      const usersData = await Promise.all(
        snapshot.docs.map(async (doc) => {
          const userData = { id: doc.id, ...doc.data() };

          // Buscar subcoleção "subscriptions"
          const subscriptionsSnapshot = await db
            .collection("users")
            .doc(doc.id)
            .collection("subscriptions")
            .limit(1)
            .get();

          if (!subscriptionsSnapshot.empty) {
            const subscriptionData = subscriptionsSnapshot.docs[0].data();
            userData.status = subscriptionData.status || "";
          } else {
            userData.status = "";
          }

          return userData;
        })
      );

      // Contar os tipos de status e agrupar usuários por status
      const counts = { active: 0, cortesy: 0, canceled: 0, past_due: 0 };
      const groups = { active: [], cortesy: [], canceled: [], past_due: [] };

      usersData.forEach((user) => {
        if (user.status && counts[user.status] !== undefined) {
          counts[user.status]++;
          groups[user.status].push({
            id: user.id,
            nome: user.profile?.nomeCompleto || user.groupName,
            email: user.email || user.profile?.email || "",
            recordsCount: user.recordsCount || 0,
          });
        }
      });

      setUsers(usersData);
      setStatusCounts(counts);
      setGroupedUsers(groups);
    };

    fetchUsersWithStatus();
  }, []);

  const handleSort = () => {
    const isAsc = order === "asc";
    setOrder(isAsc ? "desc" : "asc");
  };

  const sortedUsers = [...users].sort((a, b) => {
    const firstValue = a.recordsCount || 0;
    const secondValue = b.recordsCount || 0;
    return order === "asc" ? firstValue - secondValue : secondValue - firstValue;
  });

  return (
    <div>
      {/* Tabela de resumo de status */}
      <TableContainer component={Paper} style={{ marginBottom: "20px" }}>
        <Table sx={{ minWidth: 400 }} size="small" aria-label="status table">
          <TableHead>
            <TableRow>
              <TableCell>STATUS</TableCell>
              <TableCell align="right">QUANTIDADE</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(statusCounts).map(([status, count]) => (
              <TableRow key={status}>
                <TableCell>{status}</TableCell>
                <TableCell align="right">{count}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Tabelas de usuários por status */}
      {Object.entries(groupedUsers).map(([status, users]) => (
        <TableContainer
          component={Paper}
          style={{ marginBottom: "20px" }}
          key={status}
        >
          <Table sx={{ minWidth: 400 }} size="small" aria-label={`${status} table`}>
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={4}
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    textAlign: "left",
                  }}
                >
                  Usuários com status: {status} ({users.length})
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>UID</TableCell>
                <TableCell>NOME</TableCell>
                <TableCell>EMAIL</TableCell>
                <TableCell>RECORDS COUNT</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.length > 0 ? (
                users.map((user) => (
                  <TableRow key={user.id}>
                    <TableCell>{user.id}</TableCell>
                    <TableCell>{user.nome}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>{user.recordsCount}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    Nenhum usuário encontrado.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ))}

      {/* Tabela detalhada de usuários */}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="users table">
          <TableHead>
            <TableRow>
              <TableCell>DATA</TableCell>
              <TableCell align="right">UID</TableCell>
              <TableCell align="right">NOME</TableCell>
              <TableCell align="right">EMAIL</TableCell>
              <TableCell align="right">TELEFONE</TableCell>
              <TableCell align="right">
                <TableSortLabel
                  active={orderBy === "recordsCount"}
                  direction={order}
                  onClick={handleSort}
                >
                  RECORDS COUNT
                </TableSortLabel>
              </TableCell>
              <TableCell align="right">STATUS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedUsers.map((user) => (
              <TableRow
                key={user.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="user">
                  {user.nome}
                </TableCell>
                <TableCell align="right">{user.id}</TableCell>
                <TableCell align="right">
                  {user.profile ? user.profile.nomeCompleto : user.groupName}
                </TableCell>
                <TableCell align="right">
                  {user.email ? user.email : user.profile?.email || ""}
                </TableCell>
                <TableCell align="right">
                  {user.profile ? user.profile.telefone : ""}
                </TableCell>
                <TableCell align="right">
                  {user.recordsCount ? user.recordsCount : 0}
                </TableCell>
                <TableCell align="right">{user.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
